import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { Grid as VirtualizedGrid } from 'react-virtualized'

import styles from './grid-content.css'

const GridContent = ({
  cellRenderer,
  height,
  width,
  cellWidth,
  rowCount,
  columnCount,
  onScroll,
  calculateRowHeight,
  setRef,
}) => (
  <div styleName="content">
    <VirtualizedGrid
      cellRenderer={cellRenderer}
      columnCount={columnCount}
      columnWidth={cellWidth}
      height={height}
      onScroll={onScroll}
      ref={setRef}
      rowCount={rowCount}
      rowHeight={calculateRowHeight}
      styleName="grid"
      width={width}
    />
  </div>
)

GridContent.propTypes = {
  cellRenderer: PropTypes.func.isRequired,
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  cellWidth: PropTypes.number.isRequired,
  rowCount: PropTypes.number.isRequired,
  columnCount: PropTypes.number.isRequired,
  onScroll: PropTypes.func.isRequired,
  calculateRowHeight: PropTypes.func.isRequired,
  setRef: PropTypes.func.isRequired,
}

export default CSSModules(GridContent, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid/grid-content/grid-content.js
 **/